import { Address } from "address-lookup";

import { IIAddress } from "@/contract/generated/electrify-v1";

export const formatAddressDetails = (addressDetails: Address): IIAddress => {
  return {
    unitNumber: addressDetails.unitNumber,
    streetNumber: addressDetails.streetNumber,
    streetName: addressDetails.streetName,
    streetType: addressDetails.streetType,
    suburb: addressDetails.city,
    state: addressDetails.state,
    postcode: addressDetails.postcode,
    dpid: addressDetails.dpid ?? undefined,
  };
};
